import React, { useEffect, useState } from "react";
import { CardTitle } from "../ui/card";
import { Label } from "../ui/label";
import CustomLabelText from "../CustomLabelText";
import SearchSelect from "../SearchSelect";
import {
  cddCustomerTypeOptions,
  cddOptions,
  // entityType,
  riskProfile,
} from "../../config";
import ReactInputMask from "react-input-mask";
import { cn } from "../../lib/utils";
import { Button } from "../ui/button";
import { FieldArray } from "formik";
import VerificationRow from "../VerificationRow";
import { Loader2, MessageSquareShareIcon } from "lucide-react";
import { Textarea } from "../ui/textarea";
import { ResponsiveDrawerForm } from "../ResponsiveDrawerForm";
import EscalatedModal from "../../pages/AML-CTF/CDD/EscalatedModal";
import KYCVerifyModal from "./KYCVerifyModal";
import { formatSubcontractorName } from "../../lib/Misc";
import BeneficaryRow from "../BeneficaryRow";
import { DateInputPicker } from "../DateInputPicker";
import { Input } from "../ui/input";
import SuburbSelect from "../SuburbSelect";
import PostalCodeInput from "../PostalCodeInput";
import { SuburbList } from "../../lib/OptionsAPI";

const VerificationStep = ({
  values,
  errors,
  handleBlur,
  setFieldValue,
  loading,
  handleChange,
  mainData,
  organizationData,
  edit,
  verificationMethods,
  verificationTypes,
  setVerificationTypes,
  setLoading,
  fetchData,
  user = false,
  stateListing,
  stateLoading,
}) => {
  const [confirmEscalated, setConfirmEscalated] = useState(false);

  const toggleConfirmEscalated = () => {
    setConfirmEscalated(!confirmEscalated);
  };

  const [userLoading, setUserLoading] = useState(false);
  const [userListing, setUserListing] = useState([]);
  const [userList, setUserList] = useState([]);

  const [suburbLoading, setSuburbLoading] = useState(false);
  const [suburbListing, setSuburbListing] = useState([]);
  const [suburbList, setSuburbList] = useState([]);

  const FetchSuburbList = async (state_id) => {
    await SuburbList(state_id, 1, setSuburbLoading, setSuburbList, true);
  };

  useEffect(() => {
    if (suburbList) {
      let suburbTempListing = suburbList?.map((item) => ({
        ...item,
        value: item.id,
        label: item.name,
      }));
      setSuburbListing(suburbTempListing || []);
    } else {
      setSuburbListing([]);
    }
  }, [suburbList]);

  useEffect(() => {
    if (userList) {
      let userTempListing = userList?.map((item) => ({
        ...item,
        value: item?.id,
        label: formatSubcontractorName(item),
      }));
      setUserListing(userTempListing || []);
    } else {
      setUserListing([]);
    }
  }, [userList]);

  if (values?.type !== "2" && values.verifications?.length === 0) {
    setFieldValue("verifications", [
      {
        method: "",
        type: "",
        document_number: "",
        verified_by: "",
        date_verified: "",
        verified: 0,
      },
    ]);
  }

  return (
    <div className="grid gap-4 pt-4">
      <CardTitle className="text-md">
        <div className="flex w-full items-center justify-between">
          <div>
            {user ? "KYE" : values?.type === "2" ? "KYB" : "KYC"} Verification
          </div>
        </div>
      </CardTitle>
      {user ? (
        <>
          <div className="grid md:grid-cols-3 gap-4">
            <div className="grid gap-2">
              <div className="min-w-0">
                <Label htmlFor="verification_date">
                  <CustomLabelText
                    labelText="Date Of Birth"
                    errorField={errors?.dob}
                  />
                </Label>
                <div className="relative mt-2">
                  <DateInputPicker
                    date={values?.dob ? values?.dob : ""}
                    onSelect={(e) => {
                      setFieldValue("dob", e);
                    }}
                    inputClassName="w-full"
                    className={""}
                    disabledDate={{ after: new Date() }}
                  />
                </div>
              </div>
            </div>

            <div className="grid gap-1">
              <Label htmlFor="street">
                <CustomLabelText
                  required={false}
                  labelText="Street Address"
                  errorField={errors?.street}
                />
              </Label>
              <Input
                id="street"
                placeholder="Enter Street"
                required
                name="street"
                onChange={(e) => {
                  setFieldValue("street", e?.target?.value);
                }}
                onBlur={handleBlur}
                value={values?.street}
                className={
                  errors?.street && `focus-visible:ring-red-500 border-red-500`
                }
              />
            </div>
            <div className="grid gap-2">
              <div className="min-w-0">
                <Label htmlFor="state_id">
                  <CustomLabelText
                    required={false}
                    labelText="State"
                    errorField={errors?.state_id}
                  />
                </Label>
                <div className="relative mt-2">
                  <SearchSelect
                    frameworks={stateListing}
                    optionType={"State"}
                    clearable={true}
                    onClear={() => {
                      setFieldValue("state_id", "");
                      setFieldValue("suburb_id", "");
                      setSuburbList([]);
                    }}
                    handleSelect={(e) => {
                      setFieldValue("state_id", e);
                      setFieldValue("suburb_id", "");
                      setSuburbList([]);
                      FetchSuburbList(e);
                    }}
                    handleBlur={handleBlur}
                    className={
                      errors?.state_id &&
                      `focus-visible:ring-red-500 border-red-500`
                    }
                    disabled={false}
                    initialValue={values?.state_id}
                  />
                  {stateLoading && (
                    <span className="absolute top-2 right-2 animate-spin">
                      <Loader2 width={20} height={20} />
                    </span>
                  )}
                </div>
              </div>
            </div>

            <div className="grid gap-2">
              <div className="min-w-0">
                <Label htmlFor="suburb_id">
                  <CustomLabelText
                    required={false}
                    labelText="Suburb"
                    errorField={errors?.suburb_id}
                  />
                </Label>
                <div className="relative mt-2">
                  <SuburbSelect
                    state_id={values?.state_id} // Pass the selected state ID
                    frameworkData={suburbListing} // List of suburbs
                    loading={suburbLoading}
                    onClear={() => {
                      setFieldValue("suburb_id", "");
                    }}
                    optionType="Suburb"
                    handleSelect={(e) => {
                      setFieldValue("suburb_id", e);
                    }}
                    name="suburb_id"
                    handleBlur={handleBlur}
                    className={
                      errors?.suburb_id &&
                      `focus-visible:ring-red-500 border-red-500`
                    }
                    disabled={values?.state_id ? false : true}
                    initialValue={values?.suburb_id}
                    setSuburbList={setSuburbList} // Update suburb list as new data loads
                    setSuburbLoading={setSuburbLoading} // Control loading state
                  />
                  {suburbLoading && (
                    <span className="absolute top-2 right-2 animate-spin">
                      <Loader2 width={20} height={20} />
                    </span>
                  )}
                </div>
              </div>
            </div>
            <div className="grid gap-2">
              <Label htmlFor="postal_code">
                <CustomLabelText
                  required={false}
                  labelText="Postal Code"
                  errorField={errors?.postal_code}
                />
              </Label>
              <PostalCodeInput
                id="postal_code"
                placeholder="Enter Postal Code"
                required={false}
                name="postal_code"
                handleChange={(e) => {
                  setFieldValue("postal_code", e);
                }}
                handleBlur={handleBlur}
                className="justify-start"
                inputClassName={
                  errors?.postal_code &&
                  `focus-visible:ring-red-500 border-red-500`
                }
                value={values?.postal_code ? values?.postal_code : ""}
              />
            </div>
          </div>
        </>
      ) : (
        <div className="grid md:grid-cols-3 gap-4">
          <div className="grid gap-2">
            <div className="min-w-0">
              <Label htmlFor="cdd">
                <CustomLabelText
                  labelText="CDD Customer Type"
                  errorField={errors?.cdd_customer_type}
                />
              </Label>
              <div className="relative mt-2">
                <SearchSelect
                  frameworks={cddCustomerTypeOptions}
                  optionType={"CDD Customer Type"}
                  handleSelect={(e) => {
                    //   setSectionType(
                    //     `Onboarding-${e === "1" ? "Ongoing" : "Initial"}`,
                    //   );
                    //   setFieldValue("cdd_customer_type", e);
                  }}
                  handleBlur={handleBlur}
                  className={
                    errors?.cdd_customer_type &&
                    `focus-visible:ring-red-500 border-red-500`
                  }
                  disabled={true}
                  initialValue={values?.cdd_customer_type}
                />
              </div>
            </div>
          </div>

          <div className="grid gap-2">
            <div className="min-w-0">
              <Label htmlFor="risk">
                <CustomLabelText
                  labelText="Risk Profile"
                  errorField={errors?.risk}
                />
              </Label>
              <div className="relative mt-2">
                <SearchSelect
                  frameworks={riskProfile}
                  optionType={"Risk Profile"}
                  handleSelect={(e) => {
                    //   setFieldValue("risk", e);
                  }}
                  handleBlur={handleBlur}
                  className={
                    errors?.risk && `focus-visible:ring-red-500 border-red-500`
                  }
                  disabled={true}
                  initialValue={values?.risk}
                />
              </div>
            </div>
          </div>

          <div className="grid gap-2">
            <div className="min-w-0">
              <Label htmlFor="cdd">
                <CustomLabelText
                  labelText="CDD Type"
                  errorField={errors?.cdd}
                />
              </Label>
              <div className="relative mt-2">
                <SearchSelect
                  frameworks={cddOptions}
                  optionType={"CDD Type"}
                  handleSelect={(e) => {
                    //   setFieldValue("cdd", e);
                  }}
                  handleBlur={handleBlur}
                  className={
                    errors?.cdd && `focus-visible:ring-red-500 border-red-500`
                  }
                  disabled={true}
                  initialValue={values?.cdd}
                />
              </div>
            </div>
          </div>
        </div>
      )}
      {values?.is_kyc ? (
        values?.type === "2" ? (
          <>
            <div className="grid md:grid-cols-3 gap-4">
              <div className="grid gap-2">
                <Label htmlFor="abn">
                  <CustomLabelText
                    // required={values?.entity_type === "1" ? true : false}
                    required={false}
                    labelText="ABN"
                    errorField={errors?.abn}
                  />
                </Label>
                <ReactInputMask
                  id="abn"
                  type="text"
                  name="abn"
                  value={values?.abn ? values?.abn : ""}
                  onChange={handleChange}
                  onBlur={handleBlur}
                  mask="99 999 999 999"
                  maskChar={null}
                  autoComplete="off"
                  onKeyPress={(e) => {
                    e.which === 13 && e.preventDefault();
                  }}
                  className={
                    errors?.abn
                      ? `${cn(
                          "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
                        )} focus-visible:ring-red-500 border-red-500`
                      : cn(
                          "flex h-9 w-full rounded-md border border-input bg-transparent px-3 py-1 text-sm shadow-sm transition-colors file:border-0 file:bg-transparent file:text-sm file:font-medium placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-webPrimary dark:focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50",
                        )
                  }
                />
              </div>

              {/* <div className="grid gap-2">
                <Label htmlFor="entity_type">
                  <CustomLabelText
                    required={true}
                    labelText="Entity Type"
                    errorField={errors?.entity_type}
                  />
                </Label>
                <div className="relative">
                  <SearchSelect
                    frameworks={entityType}
                    optionType={"Entity Type"}
                    handleSelect={(e) => {
                      setFieldValue("entity_type", e);
                    }}
                    handleBlur={handleBlur}
                    className={
                      errors?.entity_type &&
                      `focus-visible:ring-red-500 border-red-500`
                    }
                    disabled={false}
                    initialValue={values?.entity_type}
                  />
                </div>
              </div> */}

              <div className="grid gap-2">
                <Label htmlFor="kyb_verify">
                  <CustomLabelText
                    required={false}
                    labelText="KYB Verify"
                    errorField={errors?.kyb_verify}
                  />
                </Label>

                <KYCVerifyModal
                  loading={loading}
                  setLoading={setLoading}
                  values={values}
                  index={0}
                  verificationTypes={verificationTypes}
                  kycId={mainData?.kyc?.id}
                  setFieldValue={setFieldValue}
                  method={0}
                  organizationData={organizationData?.organizationData}
                  verifyStatus={
                    values?.beneficiaries?.length > 0
                      ? values?.risk_assessment_id &&
                        values?.beneficiaries?.some(
                          (item) =>
                            item?.first_name &&
                            item?.last_name &&
                            item?.percentage,
                        )
                        ? 1
                        : mainData?.kyc?.status
                      : mainData?.kyc?.status
                  }
                  errors={errors}
                  handleChange={handleChange}
                  handleBlur={handleBlur}
                  fetchData={fetchData}
                />
              </div>
            </div>

            <hr className="mb-4" />
            <FieldArray name="beneficiaries">
              {({ push, remove }) => (
                <div className="space-y-6">
                  {values?.beneficiaries?.map((row, index) => (
                    <BeneficaryRow
                      key={index}
                      index={index}
                      values={values}
                      push={push}
                      errors={errors}
                      remove={remove}
                    />
                  ))}

                  {values?.beneficiaries?.length === 0 && (
                    <Button
                      type="button"
                      variant="outline"
                      onClick={() =>
                        push({
                          first_name: "",
                          last_name: "",
                          percentage: "",
                        })
                      }
                    >
                      Add Beneficiaries
                    </Button>
                  )}
                </div>
              )}
            </FieldArray>
          </>
        ) : (
          <>
            {values?.cdd && values?.risk && (
              <FieldArray name="verifications">
                {({ push, remove }) => (
                  <div className="space-y-6">
                    {values.verifications?.map((row, index) => (
                      <VerificationRow
                        key={index}
                        index={index}
                        values={values}
                        push={push}
                        errors={errors}
                        remove={remove}
                        setLoading={setLoading}
                        verificationMethods={verificationMethods}
                        verificationTypes={verificationTypes}
                        mainData={mainData}
                        organizationData={organizationData}
                        kycId={mainData?.kyc?.id}
                        handleChange={handleChange}
                        handleBlur={handleBlur}
                        userListing={userListing}
                        setUserList={setUserList}
                        userLoading={userLoading}
                        setUserLoading={setUserLoading}
                        fetchData={fetchData}
                        setVerificationTypes={setVerificationTypes}
                        user={user}
                      />
                    ))}

                    {values.verifications?.length === 0 && (
                      <Button
                        type="button"
                        variant="outline"
                        onClick={() =>
                          push({
                            method: "",
                            type: "",
                            document_number: "",
                            verified_by: "",
                            date_verified: "",
                            verified: 0,
                          })
                        }
                      >
                        VerifiyID
                      </Button>
                    )}
                  </div>
                )}
              </FieldArray>
            )}

            {values?.risk === "1" && !values?.compliance_manager_id && !user ? (
              <>
                <hr />
                <Button
                  className="w-fit"
                  onClick={(e) => {
                    e.preventDefault();
                    toggleConfirmEscalated();
                  }}
                >
                  <span className="flex gap-2 justify-start">
                    <MessageSquareShareIcon size={18} />
                    Escalate
                  </span>
                </Button>
              </>
            ) : values?.compliance_manager_id && !user ? (
              <>
                <div>
                  <p>
                    <b>Escalated To:</b> {values?.compliance_manager_name}
                  </p>
                  <p>
                    <b>Reason:</b> {values?.reason}
                  </p>
                </div>
              </>
            ) : (
              <></>
            )}

            <div className="grid md:grid-cols-1 gap-4">
              <div className="grid gap-2">
                <Label htmlFor="notes">
                  <CustomLabelText
                    labelText="Note"
                    errorField={errors?.notes}
                  />
                </Label>
                <Textarea
                  name="notes"
                  rows={4}
                  placeholder="How did you verify Individual's Full Name AND Either Residential Address OR DOB? Or add reasoning/notes."
                  onChange={handleChange}
                  onBlur={handleBlur}
                  value={values.notes}
                  // disabled={edit && mainData?.kyc?.status ? true : false}
                />
              </div>
            </div>
            {!user && (
              <div className="grid md:grid-cols-1 gap-4">
                <div className="grid gap-2">
                  <Label htmlFor="ntf_note">
                    <CustomLabelText
                      labelText="Nature & Purpose of Transaction"
                      errorField={errors?.ntf_note}
                    />
                  </Label>
                  <Textarea
                    name="ntf_note"
                    rows={4}
                    placeholder="Write a note of Nature & Purpose of Transaction"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    value={values.ntf_note}
                    // disabled={edit && mainData?.kyc?.status ? true : false}
                  />
                </div>
              </div>
            )}
          </>
        )
      ) : (
        <></>
      )}

      {confirmEscalated && (
        <ResponsiveDrawerForm
          description={""}
          title={`Escalated`}
          handleOpen={() => {}}
          handleClose={() => {
            toggleConfirmEscalated();
          }}
          popupType={"cdds"}
          write={true}
          buttonText={""}
          open={confirmEscalated}
          buttonClassName={""}
          setOpen={setConfirmEscalated}
          className={"sm:max-w-3xl"}
        >
          <EscalatedModal
            data={{
              id: mainData?.kyc?.id ? mainData?.kyc?.id : "",
              compliance_manager_id: values?.compliance_manager_id,
              reason: values?.reason,
            }}
            toggleConfirmEscalated={toggleConfirmEscalated}
            fetchData={() => {}}
            setFieldValue={setFieldValue}
          />
        </ResponsiveDrawerForm>
      )}
    </div>
  );
};

export default VerificationStep;
